/**
 * MobileShell 根布局（Next.js 风格的 __layout.tsx 约定）。
 *
 * 这是 src/app/routes/ 下所有同级路由（index.tsx / home.tsx / …）的
 * 外层 layout。MobileShell 自身已经实现了 Outlet 渲染，所以我们直接
 * 把 MobileShell 作为路由 element，不再额外包一层。
 *
 * 不在本 layout 内的路由（/login）走 App.tsx 里单独的 Route 分支。
 */

import React from 'react';
import { MobileShell } from '../../shared/ui/MobileShell';
import { UnreadBadgeProvider } from '../../features/notifications/components/UnreadBadgeProvider';

/** 仅登录后的移动端壳层挂载通知数据源；/login 不应触发通知请求。 */
export default function AuthenticatedLayout(): React.JSX.Element {
  return (
    <UnreadBadgeProvider>
      <MobileShell />
    </UnreadBadgeProvider>
  );
}
